<template>
  <CardSettingsIcon
    :class="$style.card"
    :icon="icon"
    :instructions="instructions"
    :title="title"
  >
    <div
      v-for="server in value"
      :key="server.id"
      :class="$style.item"
    >
      <FieldsPasswordConfiguration
        :name="server.id"
        :optionsAccountLockout="optionsAccountLockout"
        :optionsPasswordExpiration="optionsPasswordExpiration"
        :title="server.name"
        :value="server"
        @input="(value) => handleInput(server.id, value)"
      />
    </div>
  </CardSettingsIcon>
</template>

<script>
import { cloneDeep } from 'lodash';
import CardSettingsIcon from 'client/settings/Security/CardSettingsIcon.vue';
import FieldsPasswordConfiguration from 'client/settings/Security/FieldsPasswordConfiguration.vue';

export default {
  name: 'PasswordConfigurationMulti',

  components: {
    CardSettingsIcon,
    FieldsPasswordConfiguration,
  },

  props: {
    icon: {
      type: String,
      required: true,
    },
    instructions: {
      type: String,
      default: '',
    },
    optionsAccountLockout: {
      type: Array,
      default: () => ([]),
    },
    optionsPasswordExpiration: {
      type: Array,
      default: () => ([]),
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => ([]),
    },
  },

  methods: {
    handleInput(id, newValue) {
      const returnArray = cloneDeep(this.value);
      const index = returnArray.findIndex(server => server.id === id);

      returnArray[index] = newValue;
      this.$emit('input', returnArray);
    },
  },
};
</script>

<style module>
@import '../settings.css';
</style>
